"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mongoose_1 = require("mongoose");
const ComputeChangeSchema = new mongoose_1.Schema({
    project_id: {
        type: mongoose_1.Schema.Types.ObjectId,
        ref: "Project",
        required: true,
        index: true,
    },
    user_id: {
        type: mongoose_1.Schema.Types.ObjectId,
        ref: "User",
        required: true,
        index: true,
    },
    team_id: {
        type: mongoose_1.Schema.Types.ObjectId,
        ref: "Team",
        required: false,
        index: true,
    },
    subscription_id: {
        type: mongoose_1.Schema.Types.ObjectId,
        ref: "Subscription",
        required: true,
        index: true,
    },
    timestamp: {
        type: Date,
        default: Date.now,
        required: true,
    },
    previous: {
        cpu: { type: Number, required: true },
        memory: { type: Number, required: true },
        storage: { type: Number, required: true },
    },
    current: {
        cpu: { type: Number, required: true },
        memory: { type: Number, required: true },
        storage: { type: Number, required: true },
    },
    costs: {
        startDate: { type: Date, required: true },
        endDate: { type: Date },
        cpuCost: { type: Number, default: 0 },
        memoryCost: { type: Number, default: 0 },
        storageCost: { type: Number, default: 0 },
        totalCost: { type: Number, default: 0 },
    },
    billed: {
        type: Boolean,
        default: false,
    },
});
exports.default = (0, mongoose_1.model)("ComputeChange", ComputeChangeSchema, "compute_changes");
